import { Dispatch, FC, useContext, useState } from 'react'
import { InternalContext } from '../contexts/InternalContext'
import './ControlsVolumeControl.scss'
import { ControlsVolumeValue } from './ControlsVolumeValue'
import { useVolumeControl } from './hooks/useVolumeControl'

interface Props {
  setEditing: Dispatch<boolean>
}

export const ControlsVolumeControl: FC<Props> = ({ setEditing }) => {
  const {
    audioPlayer: { volume },
  } = useContext(InternalContext)
  const [element, setElement] = useState<HTMLDivElement | null>(null)

  useVolumeControl(element, setEditing)

  return (
    <div className="ControlsVolumeControl" ref={setElement}>
      <ControlsVolumeValue style={{ color: 'black' }} />

      <div className="value" style={{ width: `${100 * volume}%` }}>
        <ControlsVolumeValue />
      </div>
    </div>
  )
}
